class AccordionBlock {
  constructor(element) {
    this.accordion = element;
    this.trigger = this.accordion.querySelector('.accordion-block__trigger');
    this.content = this.accordion.querySelector('.accordion-block__content');
    this.animationDuration =
      parseInt(this.accordion.dataset.animationDuration) || 300;
    this.isAnimating = false;
    this.init();
  }

  init() {
    if (!this.trigger || !this.content) return;
    this.trigger.addEventListener('click', () => this.toggle());
    this.trigger.addEventListener('keydown', (e) => this.handleKeydown(e));
    const isOpen = this.trigger.getAttribute('aria-expanded') === 'true';
    if (isOpen) {
      this.content.style.maxHeight = this.content.scrollHeight + 'px';
    } else {
      this.content.style.maxHeight = '0';
    }
  }

  handleKeydown(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      this.toggle();
    }
  }

  toggle() {
    if (this.isAnimating) return;
    const isExpanded = this.trigger.getAttribute('aria-expanded') === 'true';

    if (!isExpanded) {
      this.closeOthers();
    }

    if (isExpanded) {
      this.close();
    } else {
      this.open();
    }
  }

  closeOthers() {
    const allAccordions = document.querySelectorAll('.accordion-block');
    allAccordions.forEach((accordion) => {
      if (accordion !== this.accordion) {
        const instance = accordion.accordionInstance;
        if (
          instance &&
          instance.trigger.getAttribute('aria-expanded') === 'true'
        ) {
          instance.close();
        }
      }
    });
  }

  open() {
    this.isAnimating = true;
    this.trigger.setAttribute('aria-expanded', 'true');
    this.content.removeAttribute('hidden');
    this.content.classList.add('is-opening');
    this.accordion.classList.add('is-open');

    const scrollHeight = this.content.scrollHeight;
    this.content.style.maxHeight = '0';
    this.content.offsetHeight; // Force reflow

    this.content.style.transition = `max-height ${this.animationDuration}ms cubic-bezier(0.4, 0, 0.2, 1)`;
    this.content.style.maxHeight = scrollHeight + 'px';

    setTimeout(() => {
      this.content.classList.remove('is-opening');
      this.content.classList.add('is-open');
      this.isAnimating = false;
      this.content.style.maxHeight = 'none';
    }, this.animationDuration);
  }

  close() {
    this.isAnimating = true;
    const scrollHeight = this.content.scrollHeight;
    this.content.style.maxHeight = scrollHeight + 'px';
    this.content.classList.remove('is-open');
    this.content.classList.add('is-closing');
    this.accordion.classList.remove('is-open');

    this.content.offsetHeight; // Force reflow

    this.content.style.transition = `max-height ${this.animationDuration}ms cubic-bezier(0.4, 0, 0.2, 1)`;
    this.content.style.maxHeight = '0';

    setTimeout(() => {
      this.trigger.setAttribute('aria-expanded', 'false');
      this.content.setAttribute('hidden', '');
      this.content.classList.remove('is-closing');
      this.isAnimating = false;
    }, this.animationDuration);
  }

  destroy() {
    this.trigger.removeEventListener('click', this.toggle);
    this.trigger.removeEventListener('keydown', this.handleKeydown);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const accordions = document.querySelectorAll('.accordion-block');
  accordions.forEach((accordion) => {
    const instance = new AccordionBlock(accordion);
    accordion.accordionInstance = instance;
  });
});

if (window.acf) {
  window.acf.addAction('render_block_preview/type=accordion', () => {
    const accordions = document.querySelectorAll('.accordion-block');
    accordions.forEach((accordion) => {
      const instance = new AccordionBlock(accordion);
      accordion.accordionInstance = instance;
    });
  });
}
